import(/* webpackMode: "eager" */ "/opt/ZemeWeb/src/app/global-error.jsx");
